<ng-container *transloco="let t">
  <authority-labs-check-case
    [inspection]="inspection"
    [fieldSection]="fieldSection"
    [printPreview]="printPreview"
    [readonly]="readonly"
    (dataChange)="onChange()"
  >
    <mat-form-field
      dir="ltr"
      class="numerical"
      floatLabel="always"
      appearance="fill"
    >
      <mat-label>{{ t('inspection.fields.volume') }}</mat-label>
      <input
        type="number"
        min="0"
        matInput
        placeholder="0"
        [drawableField]="
          (fieldSection || '') + ':' + (inspection?.title || '') + ':volume'
        "
        [drawableFieldTitle]="t('inspection.fields.volume')"
        [drawableFieldReadonly]="readonly"
        [(ngModel)]="inspection.volume"
        [readonly]="readonly || printPreview"
        (change)="onChange()"
      />
      <span class="prefix" matSuffix>L</span>
    </mat-form-field>
  </authority-labs-check-case>
</ng-container>
